/**
 * Volatile press state of the button widgets, written by the pointer (press /
 * release gestures, keyed per pointer so multi-touch chords work) and read by
 * the per-frame signal evaluation: `drainPresses` yields each button's press
 * count since the last frame (its pulseOut), `isHeld` its sustained value-out
 * (1 while held). Never persisted — a button's state dies with the gesture.
 */
export class WidgetInput {
  private readonly held: Set<string>;
  private readonly presses: Map<string, number>;

  constructor() {
    this.held = new Set<string>();
    this.presses = new Map<string, number>();
  }

  press(id: string): void {
    this.held.add(id);
    this.pulse(id);
  }

  /** Records a press pulse without entering the held set (a toggle's ON press). */
  pulse(id: string): void {
    this.presses.set(id, (this.presses.get(id) ?? 0) + 1);
  }

  release(id: string): void {
    this.held.delete(id);
  }

  isHeld(id: string): boolean {
    return this.held.has(id);
  }

  drainPresses(): Map<string, number> {
    const out = new Map<string, number>(this.presses);
    this.presses.clear();
    return out;
  }
}
